import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer class="footer">
      <div class="container grid-list">
        <div class="footer-brand">
          <Link to="/" className="logo">
            <img
              src="./assets/images/logo.png"
              alt="Taxi Business"
              style={{ height: "55px" }}
            />
          </Link>

          <p class="footer-text">
            We Offer Top-Notch Transportation Solutions for Business and Tourism
            &copy; 2024 TaxiService. <br />
            All rights reserved.
          </p>

          <ul class="social-list">
            <li>
              <Link to="/" class="social-link">
                <ion-icon name="logo-facebook"></ion-icon>
              </Link>
            </li>

            <li>
              <Link to="/" class="social-link">
                <ion-icon name="logo-twitter"></ion-icon>
              </Link>
            </li>

            <li>
              <Link to="/" class="social-link">
                <ion-icon name="logo-dribbble"></ion-icon>
              </Link>
            </li>

            <li>
              <Link to="/" class="social-link">
                <ion-icon name="logo-instagram"></ion-icon>
              </Link>
            </li>

            <li>
              <Link to="/" class="social-link">
                <ion-icon name="logo-youtube"></ion-icon>
              </Link>
            </li>
          </ul>
        </div>

        <ul class="footer-list">
          <li>
            <p class="h4 footer-list-title">Get in Touch</p>
          </li>

          <li>
            <address class="footer-text">
              Kisumu Airport, Nairobi, Kenya
            </address>
          </li>

          <li>
            <a href="mailto:dadyjohn2004@gmail.com" class="footer-link">
              dadyjohn2004@gmail.com
            </a>
          </li>

          <li>
            <a href="tel:+254 791 871 179" class="footer-link">
              +254 791 871 179
            </a>
          </li>
        </ul>

        <ul class="footer-list">
          <li>
            <p class="h4 footer-list-title">Learn More</p>
          </li>

          <li>
            <Link to="/" class="footer-link">
              About Us
            </Link>
          </li>

          <li>
            <Link to="/" class="footer-link">
              Our Services
            </Link>
          </li>

          <li>
            <Link to="/" class="footer-link">
              Fleet of Vehicles
            </Link>
          </li>

          <li>
            <Link to="/" class="footer-link">
              Terms of Use
            </Link>
          </li>

          <li>
            <Link to="/" class="footer-link">
              Privacy Policy
            </Link>
          </li>
        </ul>

        <div class="footer-list">
          <p class="h4 footer-list-title">Our Newsletter</p>

          <p class="footer-text">
            Subscribe to our newsletter to get the latest offers and news about
            our taxi services.
          </p>

          <form action="" class="input-wrapper">
            <input
              type="email"
              name="email_address"
              placeholder="Email Address"
              required
              class="input-field"
            />

            <button type="submit" class="submit-btn">
              Join
            </button>
          </form>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
